import React from "react";
import Button from "../button";
import { withRouter } from "react-router";

import "./style.scss";

const ErrorPageIconDark = () => <svg width="180" height="180" viewBox="0 0 180 180" fill="none"
									 xmlns="http://www.w3.org/2000/svg">
	<circle cx="90" cy="90" r="90" fill="#1B1F23"/>
	<path
		d="M164.3 145.9V149.8C164.3 153.3 161.3 156.2 157.6 156.2H22.7C19 156.2 16 153.3 16 149.8V145.9H77C77.5 147.3 78.9 148.4 80.6 148.4H99.7C101.4 148.4 102.8 147.4 103.3 145.9H164.3Z"
		fill="#555D67"/>
	<path
		d="M164.3 145.9C164.3 149.4 161.3 152.2 157.6 152.2H22.7C19 152.2 16 149.4 16 145.9H77C77.5 147.3 78.9 148.4 80.6 148.4H99.7C101.4 148.4 102.8 147.4 103.3 145.9H164.3Z"
		fill="#454C56"/>
	<path
		d="M156.7 145.9H23.7002V61.6998C23.7002 58.9998 25.9002 56.7998 28.6002 56.7998H151.9C154.6 56.7998 156.8 58.9998 156.8 61.6998L156.7 145.9Z"
		fill="#262A30"/>
	<path d="M123.6 146.2H29.9004V63.7998H150V146.2H137.4" fill="#121417"/>
	<path
		d="M90.7002 129.9H82.2002C80.8002 129.9 79.7002 128.8 79.7002 127.4C79.7002 126 80.8002 124.9 82.2002 124.9H90.7002C92.1002 124.9 93.2002 126 93.2002 127.4C93.2002 128.8 92.1002 129.9 90.7002 129.9Z"
		fill="#262A30"/>
	<path
		d="M71.9002 129.9H36.7002C35.3002 129.9 34.2002 128.8 34.2002 127.4C34.2002 126 35.3002 124.9 36.7002 124.9H71.9002C73.3002 124.9 74.4002 126 74.4002 127.4C74.4002 128.8 73.3002 129.9 71.9002 129.9Z"
		fill="#262A30"/>
	<path
		d="M107.1 118H68.7998C67.3998 118 66.2998 116.9 66.2998 115.5C66.2998 114.1 67.3998 113 68.7998 113H107.1C108.5 113 109.6 114.1 109.6 115.5C109.6 116.9 108.5 118 107.1 118Z"
		fill="#262A30"/>
	<path
		d="M58.1002 118H37.2002C35.8002 118 34.7002 116.9 34.7002 115.5C34.7002 114.1 35.8002 113 37.2002 113H58.1002C59.5002 113 60.6002 114.1 60.6002 115.5C60.6002 116.9 59.5002 118 58.1002 118Z"
		fill="#262A30"/>
	<path
		d="M62 83H37.5C36.1 83 35 81.9 35 80.5C35 79.1 36.1 78 37.5 78H62C63.4 78 64.5 79.1 64.5 80.5C64.5 81.9 63.4 83 62 83Z"
		fill="#262A30"/>
	<path
		d="M54.3002 94.7998H37.7002C36.3002 94.7998 35.2002 93.6998 35.2002 92.2998C35.2002 90.8998 36.3002 89.7998 37.7002 89.7998H54.3002C55.7002 89.7998 56.8002 90.8998 56.8002 92.2998C56.8002 93.6998 55.6002 94.7998 54.3002 94.7998Z"
		fill="#262A30"/>
	<path
		d="M89.0004 98.2C109.766 98.2 126.6 81.3659 126.6 60.6C126.6 39.8341 109.766 23 89.0004 23C68.2345 23 51.4004 39.8341 51.4004 60.6C51.4004 81.3659 68.2345 98.2 89.0004 98.2Z"
		fill="#555D67"/>
	<path
		d="M91.4179 68H86.418C85.755 68 85.1191 68.2634 84.6503 68.7322C84.1814 69.2011 83.9181 69.837 83.9181 70.5V75.5C83.9181 76.163 84.1814 76.7989 84.6503 77.2678C85.1191 77.7366 85.755 78 86.418 78H91.4179C92.081 78 92.7168 77.7366 93.1857 77.2678C93.6545 76.7989 93.9179 76.163 93.9179 75.5V70.5C93.9179 69.837 93.6545 69.2011 93.1857 68.7322C92.7168 68.2634 92.081 68 91.4179 68ZM92.3179 43.0001H85.518C85.1629 42.9975 84.8113 43.0706 84.4866 43.2146C84.1619 43.3585 83.8717 43.57 83.6351 43.835C83.3986 44.0999 83.2212 44.4122 83.1148 44.751C83.0084 45.0899 82.9754 45.4475 83.0181 45.8001L85.018 61.9C85.0549 62.2049 85.2027 62.4856 85.4332 62.6885C85.6638 62.8913 85.9609 63.0023 86.268 63H91.5679C91.875 63.0023 92.1722 62.8913 92.4027 62.6885C92.6333 62.4856 92.7811 62.2049 92.8179 61.9L94.8179 45.8001C94.8605 45.4475 94.8275 45.0899 94.7211 44.751C94.6147 44.4122 94.4373 44.0999 94.2008 43.835C93.9643 43.57 93.674 43.3585 93.3493 43.2146C93.0247 43.0706 92.673 42.9975 92.3179 43.0001Z"
		fill="white"/>
</svg>


const ErrorPageIcon = () => <svg width="180" height="180" viewBox="0 0 180 180" fill="none"
								 xmlns="http://www.w3.org/2000/svg">
	<circle cx="90" cy="90" r="90" fill="#F5F7F8"/>
	<path
		d="M164.3 145.9V149.8C164.3 153.3 161.3 156.2 157.6 156.2H22.7C19 156.2 16 153.3 16 149.8V145.9H77C77.5 147.3 78.9 148.4 80.6 148.4H99.7C101.4 148.4 102.8 147.4 103.3 145.9H164.3Z"
		fill="#777F89"/>
	<path
		d="M164.3 145.9C164.3 149.4 161.3 152.2 157.6 152.2H22.7C19 152.2 16 149.4 16 145.9H77C77.5 147.3 78.9 148.4 80.6 148.4H99.7C101.4 148.4 102.8 147.4 103.3 145.9H164.3Z"
		fill="#A2AAB4"/>
	<path
		d="M156.699 145.9H23.6992V61.6998C23.6992 58.9998 25.8992 56.7998 28.5992 56.7998H151.899C154.599 56.7998 156.799 58.9998 156.799 61.6998L156.699 145.9Z"
		fill="#DFE5E9"/>
	<path d="M123.6 146.2H29.9004V63.7998H150V146.2H137.4" fill="white"/>
	<path
		d="M90.6992 129.9H82.1992C80.7992 129.9 79.6992 128.8 79.6992 127.4C79.6992 126 80.7992 124.9 82.1992 124.9H90.6992C92.0992 124.9 93.1992 126 93.1992 127.4C93.1992 128.8 92.0992 129.9 90.6992 129.9Z"
		fill="#E9EDF0"/>
	<path
		d="M71.8992 129.9H36.6992C35.2992 129.9 34.1992 128.8 34.1992 127.4C34.1992 126 35.2992 124.9 36.6992 124.9H71.8992C73.2992 124.9 74.3992 126 74.3992 127.4C74.3992 128.8 73.2992 129.9 71.8992 129.9Z"
		fill="#E9EDF0"/>
	<path
		d="M107.099 118H68.7988C67.3988 118 66.2988 116.9 66.2988 115.5C66.2988 114.1 67.3988 113 68.7988 113H107.099C108.499 113 109.599 114.1 109.599 115.5C109.599 116.9 108.499 118 107.099 118Z"
		fill="#E9EDF0"/>
	<path
		d="M58.0992 118H37.1992C35.7992 118 34.6992 116.9 34.6992 115.5C34.6992 114.1 35.7992 113 37.1992 113H58.0992C59.4992 113 60.5992 114.1 60.5992 115.5C60.5992 116.9 59.4992 118 58.0992 118Z"
		fill="#E9EDF0"/>
	<path
		d="M62.1992 84.3999H37.6992C36.2992 84.3999 35.1992 83.2999 35.1992 81.8999C35.1992 80.4999 36.2992 79.3999 37.6992 79.3999H62.1992C63.5992 79.3999 64.6992 80.4999 64.6992 81.8999C64.6992 83.2999 63.5992 84.3999 62.1992 84.3999Z"
		fill="#E9EDF0"/>
	<path
		d="M54.2992 94.7998H37.6992C36.2992 94.7998 35.1992 93.6998 35.1992 92.2998C35.1992 90.8998 36.2992 89.7998 37.6992 89.7998H54.2992C55.6992 89.7998 56.7992 90.8998 56.7992 92.2998C56.7992 93.6998 55.5992 94.7998 54.2992 94.7998Z"
		fill="#E9EDF0"/>
	<path
		d="M89.0004 98.2C109.766 98.2 126.6 81.3659 126.6 60.6C126.6 39.8341 109.766 23 89.0004 23C68.2345 23 51.4004 39.8341 51.4004 60.6C51.4004 81.3659 68.2345 98.2 89.0004 98.2Z"
		fill="#A2AAB4"/>
	<path
		d="M91.4179 68H86.418C85.755 68 85.1191 68.2634 84.6503 68.7322C84.1814 69.2011 83.9181 69.837 83.9181 70.5V75.5C83.9181 76.163 84.1814 76.7989 84.6503 77.2678C85.1191 77.7366 85.755 78 86.418 78H91.4179C92.081 78 92.7168 77.7366 93.1857 77.2678C93.6545 76.7989 93.9179 76.163 93.9179 75.5V70.5C93.9179 69.837 93.6545 69.2011 93.1857 68.7322C92.7168 68.2634 92.081 68 91.4179 68ZM92.3179 43.0001H85.518C85.1629 42.9975 84.8113 43.0706 84.4866 43.2146C84.1619 43.3585 83.8717 43.57 83.6351 43.835C83.3986 44.0999 83.2212 44.4122 83.1148 44.751C83.0084 45.0899 82.9754 45.4475 83.0181 45.8001L85.018 61.9C85.0549 62.2049 85.2027 62.4856 85.4332 62.6885C85.6638 62.8913 85.9609 63.0023 86.268 63H91.5679C91.875 63.0023 92.1722 62.8913 92.4027 62.6885C92.6333 62.4856 92.7811 62.2049 92.8179 61.9L94.8179 45.8001C94.8605 45.4475 94.8275 45.0899 94.7211 44.751C94.6147 44.4122 94.4373 44.0999 94.2008 43.835C93.9643 43.57 93.674 43.3585 93.3493 43.2146C93.0247 43.0706 92.673 42.9975 92.3179 43.0001Z"
		fill="white"/>
</svg>


class ErrorBoundary extends React.Component {

	constructor(props) {
		super(props);
		this.state = {error: null, errorInfo: null};
		this.isLight = true;
	}

	componentDidCatch(error, errorInfo) {

		this.setState({
			error: error,
			errorInfo: errorInfo
		});

		if (/ChunkLoadError/.test(error.name)) {
			return <div>Reload you page</div>

			if (!localStorage.getItem("chunkErrorPageReloaded")) {
				localStorage.setItem("chunkErrorPageReloaded", true)
				window.location.reload()
			}
		}
	}

	componentDidMount() {
		try {
			this.isLight = window.localStorage.getItem("theme") === "dark" ? false : true;
		} catch (error) {
			console.log(error);
		}
	}

	render() {

		let {errorInfo, error} = this.state;
		let {location} = this.props;

		const handleRefreshClick = () => {
			window.location.reload();
		};

		if (errorInfo) {
			return (
				<div className="app error">

					<div className="app-body" style={{paddingTop: '0', backgroundColor: "transparent"}}>
						<main className="main ml-0" style={{height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
							<div className="container" style={{maxWidth: 1024, backgroundColor: "transparent"}}>

								<div className="error-container">
									<div className="error-page">
										<div className="error-page-icon">
											{this.isLight ? <ErrorPageIcon/> : <ErrorPageIconDark />}
										</div>
										<div className="error-page-title">
											Something went wrong...
										</div>

										<div className="error-page-info">
											{error && error.toString()} <br/>
											{location ? `Path: ${location.pathname}` : ""}
										</div>

										<Button size="large" variant="secondary" className="d-flex gap-2 align-items-center"
												onClick={handleRefreshClick}>
											<svg width="18" height="18" viewBox="0 0 18 18" fill="none"
												 xmlns="http://www.w3.org/2000/svg">
												<path
													d="M3.03711 8.24999C3.22677 6.80304 3.93728 5.47482 5.03562 4.51395C6.13396 3.55309 7.54484 3.02545 9.00416 3.02981C10.4635 3.03418 11.8712 3.57024 12.9638 4.53766C14.0563 5.50508 14.7589 6.83752 14.9399 8.28558C15.1209 9.73363 14.768 11.198 13.9471 12.4046C13.1263 13.6112 11.8939 14.4773 10.4805 14.8407C9.06719 15.2042 7.56983 15.0401 6.26876 14.3791C4.9677 13.7182 3.95211 12.6057 3.41211 11.25M3.03711 15V11.25H6.78711"
													stroke="#555D67" strokeWidth="1.5" strokeLinecap="round"
													strokeLinejoin="round"/>
											</svg>
											Refresh
										</Button>
									</div>
								</div>

							</div>
						</main>
					</div>

				</div>
			);
		}

		return this.props.children;
	}
}

export default withRouter(ErrorBoundary);
